import React from 'react';
import { Modal } from 'rsuite';
import { FormatPhone } from '../../../helpers';
import ButtonSMS from '../../../helpers/ButtonSMS';
import { alert } from '../../../helpers/rsuite/Alerts';
import { cuotitasStoreService } from '../../../services';
import QRCode from 'react-qr-code';
import { InfoPoint } from '../../../components';
import HelpOutlineIcon from '@rsuite/icons/HelpOutline';
import useTheme from '../../../hooks/useTheme';

const infoPointContent = {
    width: '340px',
    fontSize: '11px',
};

const helpIcon = {
    color: '#3699FF',
    marginLeft: 10,
    fontSize: '1.5em',
    cursor: 'pointer',
};

export function ResendSMS ({ show, onHide, tab, hash, idSignRequest, telephone }) {
    const theme = useTheme();
    //
    // Functions
    const sendSMS = () => {
        const data = {
            idSignRequest: idSignRequest,
            link: `${theme.linkUrl}/${hash}`,
            telephone: FormatPhone(telephone),
            action: 'resend',
            tab,
        };
        return cuotitasStoreService
            .sendSMS(data)
            .then(res => {
                alert('success', 'SMS enviado correctamente.');
                return true;
            })
            .catch(e => {
                alert('error', 'Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.');
                return false;
            });
    };

    return (
        <Modal
            open={show}
            onClose={onHide}
            className={`${show ? 'show in' : ''}`}
            aria-labelledby='user-create-modal'
            size="sm"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <p>Reenviar SMS</p>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='py-1'>
                <div>
                    <div className='flex col justify-content-center mx-auto w-100'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <h6 className=''>Escanea el código QR para firmar tu préstamo</h6>
                            <InfoPoint
                                placement="left"
                                content={
                                    <div style={infoPointContent}>
                                        <p className='m-1'>Para escanear este código, podés usar tu cámara o una aplicación de escaneo QR de tu teléfono.</p>
                                    </div>
                                }
                            >
                                <HelpOutlineIcon style={helpIcon} />
                            </InfoPoint>
                        </div>
                        <div className='d-flex justify-content-center w-100 mt-6 mb-6'>
                            <QRCode value={`${theme.linkUrl}/${hash}`} size={200} />
                        </div>
                    </div>
                    <p>
                            Número celular: {FormatPhone(telephone)}
                    </p>
                    <p>
                        Link: {theme.linkUrl}/{hash}
                    </p>
                </div>

            </Modal.Body>
            <Modal.Footer className='mt-4'>
                <div>
                    <ButtonSMS sendSMS={sendSMS} timeDisable={'30'} description='Reenviar' telephone={telephone}/>
                </div>
            </Modal.Footer>
        </Modal>
    );
};
